const ATTRIBUTES = {
  MANUFACTURER: "Manufacturer",
  CAPACITY: "Capacity",
  HEIGHT: "Height",
  MAX_SPEED: "Max Speed",
  HEIGHT_RESTRICTION: "Height Restriction",
  TRACK_LAYOUT: "Track Layout",
  INVERSIONS: "Inversions",
  LENGTH: "Length",
  DURATION: "Duration",
  ADMISSION_COST: "Admission Cost",
  PROPULSION: "Propulsion System",
  RESTRAINTS: "Restraints",
  DROP: "Drop",
};

export default ATTRIBUTES;
